
export const GameMode = {
  EASY: 0,
  MEDIUM: 1,
  HARD: 2
};

export const MAX_MULTIPLIERS = {
  [GameMode.EASY]: 12.00,
  [GameMode.MEDIUM]: 48.00,
  [GameMode.HARD]: 256.00
};

export const GameStatus = {
  IN_PROGRESS: 1,
  WON: 2,
  LOST: 3
};

export const BetType = {
  BALANCE: 'BALANCE',
  INVENTORY: 'INVENTORY'
};
